export default __webpack_public_path__ + "static/media/building.b9843f7f.jpg";